import { IconsProps } from '@/types/shared'

const BalanceSheetIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {/* Balance scale icon for balance sheet */}
                <line x1="12" y1="2" x2="12" y2="6" />
                <line x1="12" y1="18" x2="12" y2="22" />
                <path d="M6 6 L12 6 L18 6" />
                <path d="M3 10 L9 10 L6 6 Z" />
                <path d="M15 10 L21 10 L18 6 Z" />
                <line x1="3" y1="10" x2="3" y2="14" />
                <line x1="9" y1="10" x2="9" y2="14" />
                <line x1="15" y1="10" x2="15" y2="14" />
                <line x1="21" y1="10" x2="21" y2="14" />
                <line x1="3" y1="14" x2="9" y2="14" />
                <line x1="15" y1="14" x2="21" y2="14" />
            </svg>
        </div>
    )
}

export default BalanceSheetIcons
